import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AdminUsersService, AdminUsersListResponse } from '../../api/admin-users.service';
import { AppRole } from '../../api/api.types';

@Component({
	selector: 'of-admin-users-page',
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatCardModule,
		MatProgressBarModule,
		MatSelectModule,
		MatFormFieldModule,
	],
	template: `
		<div class="page">
			<mat-card class="card" *ngIf="vm$ | async as vm; else loading">
				<h2>Admin · Users</h2>
				<p class="muted">Manage roles. Approval is controlled via Access Requests.</p>

				<div class="actions" style="justify-content: flex-end;">
					<button mat-button (click)="refresh()">Refresh</button>
				</div>

				<div *ngFor="let u of vm.users" style="padding: 12px 0; border-top: 1px solid rgba(255,255,255,0.08);">
					<div style="display: flex; gap: 12px; align-items: center;">
						<div style="min-width: 0; flex: 1 1 auto;">
							<div style="font-weight: 600;">{{ u.email ?? '(no email)' }}</div>
							<div class="muted" style="font-size: 13px;">
								{{ u.name ?? '—' }} · {{ u.approvalStatus }}
							</div>
						</div>

						<mat-form-field appearance="fill" style="width: 180px;">
							<mat-label>Role</mat-label>
							<mat-select [value]="u.role" (selectionChange)="setRole(u.id, $event.value)">
								<mat-option value="user">user</mat-option>
								<mat-option value="gm">gm</mat-option>
								<mat-option value="global_admin">global_admin</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</mat-card>
		</div>

		<ng-template #loading>
			<div class="page">
				<mat-card class="card">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</mat-card>
			</div>
		</ng-template>
	`,
})
export class AdminUsersPage {
	private readonly refresh$ = new BehaviorSubject<void>(undefined);
	vm$: Observable<AdminUsersListResponse>;

	constructor(private readonly adminUsers: AdminUsersService) {
		this.vm$ = this.refresh$.pipe(switchMap(() => this.adminUsers.list()));
	}

	refresh() {
		this.refresh$.next();
	}

	setRole(userId: string, role: AppRole) {
		this.adminUsers.updateRole(userId, role).subscribe({
			next: () => this.refresh(),
			error: () => this.refresh(),
		});
	}
}
